import { useAuthStore } from "../Stores/AuthStore";
import IUser from "../models/user";


export default function useCurrentUser(): IUser | null | undefined {
  const auth = useAuthStore();

  return auth.user;
}

export function useCurrentUserRole() {
  const auth = useAuthStore();

  return {
    isAdminOrSupervisor: auth.user?.roles.includes("ROLE_ADMIN") || auth.user?.roles.includes("ROLE_SUPERVISOR"),
    isAdmin: auth.user?.roles.includes("ROLE_ADMIN"),
    isSupervisor: auth.user?.roles.includes("ROLE_SUPERVISOR"),
    isCommercial: auth.user?.roles.includes("ROLE_COMMERCIAL"),
    isAdminOrCommercial: auth.user?.roles.includes("ROLE_ADMIN") || auth.user?.roles.includes("ROLE_SUPER_ADMIN") || auth.user?.roles.includes("ROLE_USER_COMMERCIAL"),

    roles: auth.user?.roles,
  }
}